// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import api from '../../../../../../../services/api';

const profileService = async (data) => {
  return api(`/Sellitback.svc/GetCustomerByID?CustomerId=${data.id}&Token=${data.token}`,
    {}, 'GET');
};

const changePasswordService = async (data) => {
  return api(`/Sellitback.svc/ChangePassword?OldPassword=${data.Password}&NewPassword=${data
    .NewPassword}&CustomerID=${data.CustomerId}&Token=${data.token}`, {}, 'GET');
};

const profileEditService = async (data) => {
  const profile = Object.assign({}, data.profile);
  if (!data.pageInfo.isPaypal) {
    delete profile.paypal;
  }
  if (!data.pageInfo.isBank) {
    delete profile.bank;
  }
  return api('/Sellitback.svc/UpdateCustomer', {
    ...profile, CustomerId: data.id, Token: data.token
  }, 'POST');
};

const validatePayPalEmailService = async (data) => {
  return api(`/Sellitback.svc/ValidateUserPaymentMethod?ValidateBank=false
  &PaypalEmail=${data.PaypalEmail}&ConfirmPaypalEmail=${data.ConfirmPaypalEmail}`, {}, 'GET');
};

const verifyPhoneNumberService = async (data) => {
  return api('https://api.craftyclicks.co.uk/phone/1.1/validate', data, 'POST');
};

const verifyBankAccountService = async (data) => {
  return api('https://api.craftyclicks.co.uk/bank/1.1/validate', data, 'POST');
};

export {
  profileService,
  changePasswordService,
  profileEditService,
  validatePayPalEmailService,
  verifyPhoneNumberService,
  verifyBankAccountService
};
